module.exports = __webpack_public_path__ + "static/media/editReq.3513c165.svg";